import { Element } from "./Element";

export class Electric extends Element {
  /**
   * Creates an Electric from a plain object (useful for deserialization)
   * @param obj - Plain object with electric element data
   * @returns New Electric instance
   */
  static fromObject(obj: Partial<Electric>): Electric {
    let lastMod: Date;
    if (obj.LastMod instanceof Date) {
      lastMod = obj.LastMod;
    } else if (typeof obj.LastMod === "string") {
      lastMod = new Date(obj.LastMod);
    } else {
      lastMod = new Date();
    }

    return new Electric({
      Model: obj.Model ?? "",
      LastMod: lastMod,
      CodeSpec: obj.CodeSpec ?? "",
      CodeScope: obj.CodeScope ?? "",
      CodeValue: obj.CodeValue ?? "",
      UserLabel: obj.UserLabel ?? "",
      Parent: obj.Parent ?? "",
      FederationGUID: obj.FederationGUID ?? "",
      JSONProperties: obj.JSONProperties ?? "",
    });
  }
}


